import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthBackendService } from "../../../domain/auth/service/auth-backend.service";
import { FRONT_URLS } from "../../../util/common/url-parts";
import { OrcaLogoComponent } from "../orca-logo-svg/orca-logo-svg.component";


@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: [
    './maintenance.component.scss',
  ],
  imports: [
    OrcaLogoComponent,
  ],
})
export class MaintenanceComponent implements OnInit {
  private router = inject(Router);
  private authService = inject(AuthBackendService);

  protected readonly TITLE = 'The website is being updated';
  protected readonly SUB_TITLE = 'We’re currently working on the website to make it even better. Should not take long, so try login again a bit later.';

  ngOnInit(): void {
    this.authService.getMaintenance()
      .subscribe((isMaintenance) => {
        if (!isMaintenance) {
          this.back();
        }
      });
  }

  back(): void {
    this.router.navigate([FRONT_URLS.LOGIN]);
  }
}
